import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { FB_COLLECTION_PATH } from "./postActionTypes";


export async function fx_FB_WerkerUpdateAll(fromUID: string, schedulerUID: string, jobID: string, additionalDetails: any) {

  // There is a Google Cloud Function listening (werkerUpdateAll) to the collection below.
  // The GCF identifies all associated werkers for the job and sends them the update.
  const jobUpdateRef = collection(db, FB_COLLECTION_PATH.Users);
  await addDoc(collection(jobUpdateRef, fromUID, "jobUpdatePending"), {
    JobInfo: {
      fromUID: fromUID,
      schedulerUID: schedulerUID,
      jobID: jobID,
      additionalDetails: additionalDetails,
    }
  });

  return ({"status":"sent"})
}
